import {Api} from "./user-gw";
import {loadStateFromLS} from '../app/context';

export const CApi = () => new Api({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {Authorization: `Bearer ${loadStateFromLS().token}`},
});